<template>
  <!-- 代开多家 -->
  <div>
    <dialogModel
      title="代开多家"
      width="1200px"
      :visible="VisibleUp"
      @handleClose="handleClose"
      @handleOk="handleVerifyUp"
    >
      <div class="main-body">
        <div class="Select-Con">
          <div
            v-for="(item, index) in SwitchArr"
            :key="index"
            class="Options"
            :class="Switch == item.id ? 'Select' : ''"
            @click="Switch = item.id"
          >
            {{ item.name }}
          </div>
        </div>

        <!-- 开给企业 -->
        <el-form
          v-show="Switch == 1"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm invoice-info-form"
        >
          <div class="section-row">
            <div class="section-block section-buyer">
              <div class="section-title">购买方信息</div>
              <el-form-item label="购买方企业：" prop="Purchaser" :required="true">
                <el-select
                  v-model="ruleForm.Purchaser"
                  placeholder="请选择需开票的企业"
                  filterable
                  @change="handelChange"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item.companyName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" prop="PurchaserCode" :required="true">
                <el-input
                  v-model="ruleForm.PurchaserCode"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="PurchaserPhone" :required="true">
                <el-input
                  v-model="ruleForm.PurchaserPhone"
                  placeholder="请输入联系电话"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户银行名称：" prop="PurchaseBankName" :required="false">
                <el-input
                  v-model="ruleForm.PurchaseBankName"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="基本开户账号：" prop="PurchaseAccount" :required="false">
                <el-input
                  v-model="ruleForm.PurchaseAccount"
                  placeholder="请先选择企业"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item prop="PurchaseAddress" class="is-hidden-item">
                <el-input v-model="ruleForm.PurchaseAddress" maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="是否展示：" required class="show-hide-item">
                <el-radio-group v-model="ruleForm.PurchaseShowHide">
                  <el-radio
                    v-for="item in ShowHideArr"
                    :key="'buy-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
                <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所)
                </div>
              </el-form-item>
            </div>

            <div class="section-block section-seller">
              <div class="section-title">销售方信息</div>
              <el-form-item label="销售方：" required>
                <el-input :value="seller.sellerName" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" required>
                <el-input :value="seller.sellerCreditCode" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="法定代表人(负责人)：" required>
                <el-input :value="seller.sellerLegalPerson" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="企业类型：" prop="EnterpriseType" :required="true">
                <el-radio-group
                  v-model="ruleForm.EnterpriseType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="onEnterpriseTypeChange('ruleForm')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et1-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="纳税类型：" prop="PayTaxesType" :required="true">
                <el-radio-group
                  v-model="ruleForm.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="onPayTaxesTypeChange('ruleForm')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt1-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开户银行名称：" prop="BankName" :required="false">
                <el-input
                  v-model="ruleForm.BankName"
                  placeholder="请输入开户银行（支行）"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户账号：" prop="BankNum" :required="false">
                <el-input
                  v-model="ruleForm.BankNum"
                  placeholder="请输入基本开户账号"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="住所：" required>
                <el-input :value="seller.sellerCompanyAddress" disabled maxlength="30"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="section-block section-service">
            <div class="section-title">开票信息</div>
            <el-form-item label="上传：" required>
              <div class="upload-wrap">
                <ImportRes
                  :url="UploadUrl"
                  :Upload="Upload"
                  :Switch="Switch"
                  :ClearAll="ClearAll"
                  :type="7"
                  @handleOkImport="handleOkImport"
                  @handleClose="handleClose"
                  @handleClearOut="handleClearOut"
                  @upload-status="onUploadStatus"
                ></ImportRes>
                <div class="upload-tip">
                  （上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）
                </div>
              </div>
            </el-form-item>
            <el-form-item label="需消耗：" prop="numBean" :required="true">
              <div class="consume-text">
                {{ ruleForm.numBean }}{{ ruleForm.numBean != "" ? "发票豆" : "" }}
              </div>
            </el-form-item>
          </div>
        </el-form>

        <!-- 开给自然人 -->
        <el-form
          v-show="Switch == 0"
          :model="ruleForm1"
          :rules="rules1"
          ref="ruleForm1"
          label-width="148px"
          class="demo-ruleForm invoice-info-form"
        >
          <div class="section-row">
            <div class="section-block section-seller">
              <div class="section-title">销售方信息</div>
              <el-form-item label="销售方：" required>
                <el-input :value="seller.sellerName" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" required>
                <el-input :value="seller.sellerCreditCode" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="法定代表人(负责人)：" required>
                <el-input :value="seller.sellerLegalPerson" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="企业类型：" prop="EnterpriseType" :required="true">
                <el-radio-group
                  v-model="ruleForm1.EnterpriseType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="onEnterpriseTypeChange('ruleForm1')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et0-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="纳税类型：" prop="PayTaxesType" :required="true">
                <el-radio-group
                  v-model="ruleForm1.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="onPayTaxesTypeChange('ruleForm1')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt0-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开户银行名称：" prop="BankName" :required="false">
                <el-input
                  v-model="ruleForm1.BankName"
                  placeholder="请输入开户银行（支行）"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="开户账号：" prop="BankNum" :required="false">
                <el-input
                  v-model="ruleForm1.BankNum"
                  placeholder="请输入基本开户账号"
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="住所：" required>
                <el-input :value="seller.sellerCompanyAddress" disabled maxlength="30"></el-input>
              </el-form-item>
              <el-form-item label="是否展示：" required class="show-hide-item">
                <el-radio-group v-model="ruleForm1.SalesShowHide">
                  <el-radio
                    v-for="item in ShowHideArr"
                    :key="'sale0-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
                <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所)
                </div>
              </el-form-item>
            </div>

            <div class="section-block section-service section-service-side">
              <div class="section-title">开票信息</div>
              <el-form-item label="上传：" required>
                <div class="upload-wrap">
                  <ImportRes
                    :url="UploadUrl"
                    :Upload="Upload"
                    :Switch="Switch"
                    :ClearAll="ClearAll"
                    :type="7"
                    @handleOkImport="handleOkImport"
                    @handleClose="handleClose"
                    @handleClearOut="handleClearOut"
                    @upload-status="onUploadStatus"
                  ></ImportRes>
                  <div class="upload-tip">
                    （上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="需消耗：" prop="numBean" :required="true">
                <div class="consume-text">
                  {{ ruleForm1.numBean
                  }}{{ ruleForm1.numBean != "" ? "发票豆" : "" }}
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </dialogModel>
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import VerificationPwd from "../IndexCom/VerificationPwd.vue"; //支付密码验证
import {
  companyInvoiceCalculatePrice, //计算代开发票需要消耗的发票豆
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import ImportRes from "./ImportRes.vue";
import * as API from "@/assets/api/Agency/Enterprise.js";
export default {
  props: {
    VisibleUp: {},
    seller: {}, //销售方信息
    options: {}, //公司选择
  },
  components: { ImportRes, VerificationPwd },
  data() {
    return {
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 1, name: "个体户" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 4, name: "其他" },
      ], //企业类型选项

      ruleForm: {
        Purchaser: "", //购买方
        PurchaserName: "", //法人
        PurchaserId: "", //购买方
        PurchaserCode: "", //购买方统一代码
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: "", //购买方公司类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址

        EnterpriseType: null, //企业类型
        PayTaxesType: null, // 纳税类型

        BankName: "", // 开户银行名称
        BankNum: "", //开户银行账号

        // textarea: "", //备注
        PurchaseShowHide: 1, //购买方信息展示/隐藏
        SalesShowHide: 1, //销售方信息展示/隐藏
        numBean: "", //预估发票豆
      },
      ruleForm1: {
        EnterpriseType: null, //企业类型
        PayTaxesType: null, // 纳税类型

        BankName: "", // 开户银行名称
        BankNum: "", //开户银行账号

        // textarea: "", //备注
        PurchaseShowHide: 1, //购买方信息展示/隐藏
        SalesShowHide: 1, //销售方信息展示/隐藏
        numBean: "", //预估发票豆
      },
      ShowHideArr: [
        { name: "展示", id: 1 },
        { name: "隐藏", id: 0 },
      ], //是否展示
      SwitchArr: [
        { id: 1, name: "开给企业" },
        { id: 0, name: "开给自然人" },
      ], //
      Switch: 1,
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "购买方不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserPhone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        // PurchaseBankName: [
        //   {
        //     required: true,
        //     message: "购买方开户银行名称不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        PurchaseAccount: [
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        PurchaseAddress: [
          {
            required: true,
            message: "购买方地址不能为空",
            trigger: ["blur", "change"],
          },
        ],
        EnterpriseType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        // BankName: [
        //   {
        //     required: true,
        //     message: "开户银行不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],

        BankNum: [
          // {
          //   required: true,
          //   message: "开户账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        numBean: [
          {
            required: true,
            message: "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules1: {
        // 规则未完善
        EnterpriseType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        // BankName: [
        //   {
        //     required: true,
        //     message: "开户银行不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // BankNum: [
        //   {
        //     required: true,
        //     message: "开户账号不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        BankNum: [
          // {
          //   required: true,
          //   message: "开户账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        numBean: [
          {
            required: true,
            message: "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      Upload: false,

      resList: [], //将上传的文件转为 list 列表返回到前端
      UploadUrl: "",
      VisiblePwd: false,
      ClearAll: false,
      uploading: false,
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    Switch: {
      handler(newSs, old) {
        // 切换开票格式先清空上传数据与文件展示
        this.resList = [];
        this.ruleForm.numBean = "";
        this.ruleForm1.numBean = "";
        this.uploading = false;
        this.ClearAll = true;
        this.$nextTick(() => {
          this.ClearAll = false;
        });
      },
      immediate: false,
    },
    // // 监听
    VisibleUp: {
      handler(newSs, old) {
        if (newSs == true) {
          this.ClearAll = false;
          this.ruleForm.EnterpriseType = this.seller.companyType;
          this.ruleForm.PayTaxesType = this.seller.taxType;
          this.ruleForm1.EnterpriseType = this.seller.companyType;
          this.ruleForm1.PayTaxesType = this.seller.taxType;
          this.companyInvoiceCalculatePrice();

          if (
            this.seller.companyType !== null &&
            this.seller.companyType !== ""
          ) {
            // 自动选中企业类型，不可在修改
            this.EnterpriseIsItOptional = false;
          }
          if (this.seller.taxType !== null && this.seller.taxType !== "") {
            // 自动选中纳税类型，不可在修改
            this.PayTaxesIsItOptional = false;
          }
        } else {
          this.resList = [];
          this.uploading = false;
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          this.ClearAll = true;
          this.ruleForm = {
            Purchaser: "", //购买方
            PurchaserName: "", //法人
            PurchaserId: "", //购买方
            PurchaserCode: "", //购买方统一代码
            PurchaserPhone: "", //购买方联系电话
            customerCompanyType: "", //购买方公司类型
            PurchaseBankName: "", //购买方开户银行名称
            PurchaseAccount: "", //购买方开户账号
            PurchaseAddress: "", //购买方地址

            EnterpriseType: null, //企业类型
            PayTaxesType: null, // 纳税类型

            BankName: "", // 开户银行名称
            BankNum: "", //开户银行账号

            // textarea: "", //备注
            PurchaseShowHide: 1, //购买方信息展示/隐藏
            SalesShowHide: 1, //销售方信息展示/隐藏
            numBean: "", //预估发票豆
          };
          this.ruleForm1 = {
            EnterpriseType: null, //企业类型
            PayTaxesType: null, // 纳税类型

            BankName: "", // 开户银行名称
            BankNum: "", //开户银行账号

            // textarea: "", //备注
            PurchaseShowHide: 1, //购买方信息展示/隐藏
            SalesShowHide: 1, //销售方信息展示/隐藏
            numBean: "", //预估发票豆
          };

          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
            this.$refs.ruleForm1.clearValidate();
          }, 500);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.UploadUrl = "/global/proxy/companyInvoiceUpload";
  },
  methods: {
    onUploadStatus(status) {
      this.uploading = !!status;
    },
    //点击已上传文件后方的x
    handleClearOut() {
      this.resList = [];
      this.ruleForm.numBean = "";
      this.ruleForm1.numBean = "";
    },
    //选择购买方
    handelChange(val) {
      for (var i in this.options) {
        if (this.options[i].companyName == val) {
          this.ruleForm.PurchaserCode = this.options[i].customerCreditCode;
          this.ruleForm.PurchaserPhone = this.options[i].phone;
          this.ruleForm.PurchaserId = this.options[i].id;
          this.ruleForm.PurchaserName = this.options[i].legalPerson;
          this.ruleForm.customerCompanyType =
            this.options[i].customerCompanyType;
          this.ruleForm.PurchaseBankName = this.options[i].customerBankName;
          this.ruleForm.PurchaseAccount = this.options[i].customerBankAccount;
          this.ruleForm.PurchaseAddress =
            this.options[i].customerCompanyAddress;
          // this.handleConfirm("ruleForm");
          this.$refs.ruleForm.clearValidate();
          this.companyInvoiceCalculatePrice()
        }
      }
    },

    //计算代开发票需要消耗的发票豆
    companyInvoiceCalculatePrice() {
      if (
        (this.Switch == 1 &&
          this.ruleForm.EnterpriseType !== "" &&
          this.ruleForm.EnterpriseType !== null &&
          this.ruleForm.PayTaxesType !== "" &&
          this.ruleForm.PayTaxesType !== null &&
          this.resList.length > 0) ||
        (this.Switch == 0 &&
          this.ruleForm1.EnterpriseType !== "" &&
          this.ruleForm1.EnterpriseType !== null &&
          this.ruleForm1.PayTaxesType !== "" &&
          this.ruleForm1.PayTaxesType !== null &&
          this.resList.length > 0)
      ) {
        var data = {
          data: {
            companyType:
              this.Switch == 1
                ? this.ruleForm.EnterpriseType
                : this.ruleForm1.EnterpriseType, //企业类型
            taxType:
              this.Switch == 1
                ? this.ruleForm.PayTaxesType
                : this.ruleForm1.PayTaxesType, //纳税人类型
            headType: this.Switch, //0自然人  1企业
            itemCalculateList: this.resList, //服务信息
          },
        };
        // if (data.data.companyType != null && data.data.taxType != null) {
        API.companyInvoiceCalculatePrice(data).then((res) => {
          if (res.code == 0) {
            if (this.Switch == 1) {
              this.ruleForm.numBean = res.data;
              this.$refs.ruleForm.validateField("numBean");
            } else {
              this.ruleForm1.numBean = res.data;
              this.$refs.ruleForm1.validateField("numBean");
            }
          }
        });
        // }
      }
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    //密码验证通过后提交
    handleUnderstandPwd(pwd) {
      if (this.Switch == 1) {
        var data = {
          data: {
            businessType: "PROXY_INVOICE",
            payMethod: "INVOICE_BEANS_PAY",
            password: pwd,
            businessInfo: {
              customerBankName: this.ruleForm.PurchaseBankName,
              customerBankAccount: this.ruleForm.PurchaseAccount,
              customerName: this.ruleForm.Purchaser, //客户名
              customerLegalPerson: this.ruleForm.PurchaserName, //客户法人
              customerCreditCode: this.ruleForm.PurchaserCode, //客户统一代码
              customerPhone: this.ruleForm.PurchaserPhone, //客户手机号
              customerCompanyType: this.ruleForm.customerCompanyType, //
              customerCompanyAddress: this.ruleForm.PurchaseAddress, //客戶地址
              showCustomerInfo: this.ruleForm.PurchaseShowHide, //是否展示购买方信息
              showSellerInfo: this.ruleForm.SalesShowHide, //是否展示销售放信息
              sellerTaxType: this.ruleForm.PayTaxesType, //销售方纳税类型
              sellerBankName: this.ruleForm.BankName, //销售方开户行名称
              sellerBankAccount: this.ruleForm.BankNum, //销售方开户行账号
              price: this.ruleForm.numBean, //总价格
              invoiceItemDtoList: this.resList,
            },
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleConfirmUp");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(3);
          }
        });
      } else {
        // 开给自然人
        var data = {
          data: {
            businessType: "PROXY_PERSON_INVOICE",
            payMethod: "INVOICE_BEANS_PAY",
            password: pwd,
            businessInfo: {
              sellerTaxType: this.ruleForm1.PayTaxesType, //销售方纳税类型
              sellerBankName: this.ruleForm1.BankName, //销售方开户行名称
              sellerBankAccount: this.ruleForm1.BankNum, //销售方开户行账号
              showSellerInfo: this.ruleForm1.SalesShowHide, //是否展示销售放信息
              price: this.ruleForm1.numBean, //总价格
              invoiceItemDtoList: this.resList,
            },
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleConfirmUp");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(0, 4);
          }
        });
      }
    },
    onEnterpriseTypeChange(formKey) {
      this.companyInvoiceCalculatePrice();
      this.$refs[formKey] && this.$refs[formKey].validateField("EnterpriseType");
    },
    onPayTaxesTypeChange(formKey) {
      this.companyInvoiceCalculatePrice();
      this.$refs[formKey] && this.$refs[formKey].validateField("PayTaxesType");
    },
    // 确认：先校验是否已上传，再表单校验，再支付密码
    handleVerifyUp() {
      if (this.uploading) {
        this.$tool.PromptBox("warning", "文件上传中，请稍候再确认");
        return;
      }
      if (!this.resList || this.resList.length === 0) {
        this.$tool.PromptBox(
          "error",
          "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
        );
        return;
      }
      const formRef = this.Switch == 1 ? "ruleForm" : "ruleForm1";
      this.$refs[formRef].validate((valid) => {
        if (!valid) return false;
        if (localStorage.getItem("PaymentPwd") == "false") {
          this.handleUnderstandPwd();
        } else {
          this.VisiblePwd = true;
        }
      });
    },
    // 上传完成
    handleOkImport(res) {
      const data = res && res.data && res.data.data;
      this.resList = Array.isArray(data)
        ? data
        : data && Array.isArray(data.businessDataList)
        ? data.businessDataList
        : [];
      if (!this.resList.length) {
        this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
        // 仅提示，不清空上传组件，避免先错后对时把新选文件冲掉；再次选择会走替换上传
        this.ruleForm.numBean = "";
        this.ruleForm1.numBean = "";
        return;
      }
      this.companyInvoiceCalculatePrice();
    },
  },
};
</script>
<style scoped lang="less">
.Select-Con {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 0 0 24px;
  border-bottom: 1px solid #edeff2;
  .Options {
    min-width: 96px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    margin: 0 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    font-size: 14px;
    color: #666666;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
  }
  .Select {
    color: #409eff;
    background: transparent;
    border-bottom: 2px solid #409eff;
  }
}

.main-body {
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  padding: 0;

  .section-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  .section-block {
    box-sizing: border-box;
    min-width: 0;
  }
  .section-buyer,
  .section-seller {
    flex: 1 1 0;
    width: 0;
    max-width: 50%;
  }
  .section-buyer {
    padding-right: 24px;
  }
  .section-seller {
    padding-left: 24px;
    border-left: 1px solid #edeff2;
  }
  .section-row > .section-seller:first-child {
    padding-left: 0;
    padding-right: 24px;
    border-left: none;
  }
  .section-service {
    margin-top: 8px;
    padding-top: 20px;
    border-top: 1px solid #edeff2;
  }
  .section-service-side {
    flex: 1 1 0;
    width: 0;
    max-width: 50%;
    margin-top: 0;
    padding-top: 0;
    padding-left: 24px;
    border-top: none;
    border-left: 1px solid #edeff2;
  }
  .section-title {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 700;
    color: #303133;
    line-height: 22px;
    text-align: center;
  }
  .Reminder {
    width: 100%;
    margin-top: 6px;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }
  .is-hidden-item {
    display: none !important;
  }
  .consume-text {
    color: #fe574a;
    font-size: 14px;
    line-height: 36px;
  }
  .upload-wrap {
    width: 100%;
    max-width: 900px;
  }
  .upload-tip {
    margin-top: 8px;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }
}

.invoice-info-form {
  /deep/ .el-form-item {
    margin-bottom: 10px !important;
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  /deep/ .el-form-item__label {
    white-space: nowrap !important;
    padding-right: 8px !important;
    float: none !important;
    width: auto !important;
    flex: 0 0 148px;
    text-align: right;
    line-height: 36px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
    line-height: 36px;
    width: auto !important;
    flex: 1 1 auto !important;
    min-width: 0;
    position: relative;
    padding-bottom: 20px;
  }
  /deep/ .el-form-item__error {
    position: absolute !important;
    top: auto !important;
    left: 0 !important;
    bottom: 2px !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    line-height: 16px;
    z-index: 2;
  }
  /deep/ .el-form-item.is-error .el-input__inner {
    border-color: #fe574a !important;
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: 360px !important;
    max-width: 100% !important;
    height: 36px !important;
  }
  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    width: 100% !important;
    height: 36px !important;
    line-height: 36px !important;
  }
  /deep/ .el-select .el-input__icon {
    line-height: 36px !important;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff !important;
    color: #606266 !important;
    -webkit-text-fill-color: #606266 !important;
    border-color: #409eff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
  }
  /deep/ .el-radio-group {
    display: inline-flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    vertical-align: middle;
    max-width: 100%;
    line-height: 36px;
  }
  /deep/ .el-radio {
    margin-right: 10px;
    margin-bottom: 0;
    line-height: 22px;
    white-space: nowrap;
  }
  /deep/ .el-radio__label {
    font-size: 13px;
    color: #333333;
    padding-left: 4px;
  }
  .show-hide-item {
    /deep/ .el-form-item__content {
      line-height: 22px;
      display: block;
      padding-bottom: 20px;
    }
  }
}
</style>
